import { Merchant } from '@app/models';
import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';
import { useGet } from '../../HttpClient';
import { merchantBaseUrl } from '../BaseUrls';
import { useQueryClient } from '@tanstack/react-query';

const pillarCode = "tms";
const queryKey = "get-merchants";

export function useGetMerchants() {
  const get = useGet(true, pillarCode);
  return useQueryWithErrorHandling({
    queryKey: [queryKey],
    queryFn: async () => get<Merchant[]>(`${merchantBaseUrl}/merchants`),
  });
}

export function useRefreshGetMerchants() {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: [queryKey] });
}
